import { Box, Container } from '@chakra-ui/react';
import { GetServerSidePropsContext } from 'next';
import { getSession } from 'next-auth/react';
import { FormattedMessage, useIntl } from 'react-intl';

import { withSession } from '@/lib/session';
import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';

import { H1 } from '@/components/Heading';
import NewsGrid from '@/components/News/NewsGrid';
import Pagination from '@/components/Pagination';
import Seo from '@/components/Seo';

import { LocaleProps } from '@/models/props/LocalizationProps';
import { NewsArticlesProps, NewsCardProps } from '@/models/props/NewsArticleProps';
import { NewsService } from '@/services';

function NewsPage(props: Pick<NewsCardProps, 'news'> & { page: number }) {
    const { news, page } = props;
    const intl = useIntl();

    return (
        <>
            <Seo title={intl.formatMessage({ id: 'page.news.title' })} description="Lorem ipsum" />
            <Container maxW="container.xl" paddingY={10}>
                <Box textAlign="center" mb="14">
                    <H1 mb={0}>
                        <FormattedMessage id="page.news.title" />
                    </H1>
                </Box>
                <NewsGrid data={news.data} />
                <Pagination pageCount={news.meta.pagination.pageCount} page={page} />
            </Container>
        </>
    );
}

export const getServerSideProps = withCommonServerSideProps(
    withSession(async (context: GetServerSidePropsContext) => {
        const session = await getSession(context);
        const { locale } = context;
        const {
            query: { page = 1 }
        } = context;
        const news: NewsArticlesProps = await NewsService.getLatestNews(
            locale as LocaleProps,
            10,
            +page,
            'orderNumber',
            'asc'
        );
        const { data } = news;

        if ((!session && !news) || data.length === 0 || isNaN(+page)) {
            return {
                notFound: true
            };
        }

        return {
            props: {
                news,
                page: +page
            }
        };
    })
);

export default NewsPage;
